module.exports = __webpack_public_path__ + "img/tips.50b77293.png";